import React, { useState } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import useDidMountEffect from '../hooks/useDidMountEffect';
import Button from './Button';
import Camera from '../icons/Camera';
import Keyboard from '../icons/Keyboard';
import './AddMenu.scss';

function AddMenu() {
    const [hasMounted, setHasMounted] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = () => {
        setIsOpen(!isOpen);
    }

    const buttonClasses = classnames('button--bright button--round button--large button--no-border', {
        'icon-rotate-45': isOpen,
        'icon-rotate-0': !isOpen && hasMounted
    });

    const backgroundClasses = classnames('add-menu', {
        'add-menu-background': isOpen
    });

    const menuClasses = classnames({
        'menu-hidden': !isOpen,
        'menu-visible': isOpen
    });

    useDidMountEffect(() => {
        if (!hasMounted) {
            setHasMounted(true);
        }
    }, [isOpen]);

    return (
        <div className={backgroundClasses}>
            <div className="add-menu-wrapper">
                <div className={menuClasses}>
                    <ul>
                        <li><Link to="/scan"><Camera /> Scan item</Link></li>
                        <li><Link to="/addItem"><Keyboard /> Enter item</Link></li>
                    </ul>
                </div>
                <Button
                    onClick={handleClick}
                    className={buttonClasses}
                >+</Button>
            </div>
        </div>
    );
}

export default AddMenu;